module.exports = __webpack_public_path__ + "img/1518993880.9d07e5e4.jpg";